import useCampaignTypesForClient from '@gr/portal/hooks/useCampaignTypesForClient';
import { convertEnumToReadableString } from '@gr/portal/providers/utility.provider';
import { MessageTypeEnum } from '@gr/shared/enums';
import { ICampaignTypeWithAreaCodes } from '@gr/shared/models';
import { Dropdown, IDropdownValue } from '../Dropdown';

interface ICampaignTypeDropdownProps {
  value: any;
  clientId: string;
  messageType: MessageTypeEnum;
  onChange: (newValue: IDropdownValue) => void;
  onBlur?: { (e: any): void; <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void; };
  disabled?: boolean;
  touched?: boolean;
  errorMessage?: string;
}

const CampaignTypeForClientDropdown = ({
  value,
  clientId,
  messageType,
  errorMessage,
  disabled,
  touched,
  onChange,
  onBlur,
}: ICampaignTypeDropdownProps): JSX.Element => {
  const { data, isLoading: loading } = useCampaignTypesForClient(clientId, messageType);

  const campaignTypes: ICampaignTypeWithAreaCodes[] = data?.types ?? [];

  const dropdownValues: IDropdownValue[] = campaignTypes.map((ct) => ({
    label: ct.campaignType === 'GOTV' ? 'GOTV' : convertEnumToReadableString(ct.campaignType), // We want GOTV to remain full caps
    value: ct.campaignType,
  }));

  return (
    <Dropdown
      label="Campaign Type"
      loading={loading}
      value={value ? dropdownValues.find((ct) => ct.value === value) : null}
      onChange={onChange}
      onBlur={onBlur}
      options={dropdownValues}
      disabled={disabled || dropdownValues.length === 0 || !clientId || !messageType}
      placeholder="Select a Campaign Type"
      error={touched && dropdownValues.length === 0 && clientId ? 'Client has no number for Provider' : errorMessage}
    />
  );
};

export default CampaignTypeForClientDropdown;
